import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

import { RxToggleComponent } from './rx-toggle.component';

@NgModule({
  imports: [CommonModule, MatSlideToggleModule, RxToggleComponent],
  exports: [RxToggleComponent],
})
export class RxToggleModule {}
